import React, { useEffect } from 'react'

const Cta = ({content}) => {
  useEffect(() => {
    const openEnquiry = (e) => {
      document.body.classList.add('menu-open')
    }

    const triggers = document.querySelectorAll('.trigger--popup')
    triggers.forEach((el) => el.addEventListener('click', openEnquiry))

    return () => {
      triggers.forEach((el) => el.removeEventListener('click', openEnquiry))
    }
  }, [])
  return (
  <div className='p30 fade--in' data-sal>
    <div className='text-center'>
      <p className='text-center m0 h1 m-no-space white-space max-700 ma' dangerouslySetInnerHTML={{ __html: content }}/>
    </div>
  </div>
  )
}
export default Cta
